export default __webpack_public_path__ + "ddf266aed81ac7fa64e1cff1f93f038f.png";